<template>

    <div>
        <div class="flex items-center gap-4 bg-white">
            <div class="flex-shrink-0">
                <img class="w-40 h-40 object-cover" :src="selectedGroup?.image || reservation.image"
                    :alt="selectedGroup?.name || reservation.name">
            </div>
            <div class="flex-1 min-w-0">
                <div class="text-base font-normal">
                    {{ (reservation.tagList) ? reservation.tagList : '' }}
                </div>
                <div class="text-lg font-semibold text-gray-900">{{ selectedGroup?.name }}</div>
                <div v-if="selectedGroup" class="text-gray-900 mt-4">Poziom</div>
                <div v-if="selectedGroup" class="font-semibold text-gray-900">{{ selectedGroup.tagsFormatted }}</div>

           
         
                
                <div v-if="showBadge" class="flex flex-wrap gap-2 mt-2">

                    <div v-if="selectedGroup?.hasStarted()"
                        class="flex items-center px-3 py-1 bg-red-100 text-sm font-semibold leading-normal rounded-md">
                        <div class="flex-shrink-0 w-5 h-5 text-black">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-5 h-5 text-black">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div class="justify-start text-secondary-900 text-sm font-semibold leading-normal ml-1">
                            Kurs w trakcie &nbsp;</div>
                     </div>   
            

                    <div v-if="selectedGroup?.lowAvailability"
                        class="flex items-center px-3 py-1 bg-secondary-100 text-sm font-semibold leading-normal rounded-md">
                        <div class="flex-shrink-0 w-5 h-5 text-black">
                            <svg class="w-5 h-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
                            </svg>
                        </div>
                        <div class="justify-start text-secondary-900 text-sm font-semibold leading-normal  ml-1">
                            Ostatnie wolne miejsca &nbsp;</div>

                    </div>
                    <div v-if="selectedGroup?.noAvailability"
                        class="flex items-center px-3 py-1 bg-primary-100 text-sm font-semibold leading-normal rounded-md">
                        
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-primary-500 flex-shrink-0">
  <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
</svg>

                        <div class="justify-start text-secondary-900 text-sm font-semibold leading-normal ml-1">SOLD OUT &nbsp;</div>
                    </div>


                </div>
            </div>



        </div>


    </div>
</template>

<script>

import { UsersIcon, CalendarDaysIcon, PuzzlePieceIcon, ShieldCheckIcon } from '@heroicons/vue/24/outline'
import Tags from '@/components/Tags.vue';
import { useI18n } from 'vue-i18n';



export default {

    name: 'GroupReservationHead',
    components: {
        UsersIcon,
        CalendarDaysIcon,
        PuzzlePieceIcon,
        ShieldCheckIcon,
        Tags
    },

    props: {
        reservation: {
            type: Object,
            required: true
        },
        order: {
            type: Object,
            required: false,
            default: null
        },
    },

    computed: {
        selectedGroup() {
            return this.order.selectedGroup || null;
        },
        showBadge() {
            return (this.order?.onTrial || this.selectedGroup?.lowAvailability || this.selectedGroup?.noAvailability || this.selectedGroup?.hasStarted() );
        }
    },

    data() {
        return {

            count: this.order?.count || null,
            addons: this.order?.addons || [],
            insurance: this.order?.insurance || null
        };
    },

    setup() {
        const { t } = useI18n();

        return {
            t,
            // Other returned properties and methods
        };
    },
    methods: {
        formatParticipants() {
            if (!this.count || Object.keys(this.count).length === 0) {
                return '';
            }

            const formatted = [];
            for (const [category, count] of Object.entries(this.count)) {
                if (count > 0) {
                    formatted.push(`${count} ${this.$t(category, count)}`);
                }
            }
            return formatted.join(', ');

        },
        formatInsurance() {
            if (!this.insurance) {
                return '';
            }
            return `${this.insurance.title}`;
        },
        formatAddOns() {
            if (!this.addons || this.addons.length === 0) {
                return '';
            }
            const formatted = [];
            for (const addOn of this.addons) {
                if (addOn.quantity > 1) {
                    formatted.push(`${addOn.name} x ${addOn.quantity}`);
                }
                else {
                    formatted.push(`${addOn.name}`);
                }
            }
            return formatted.join(', ');
        },

        formatDate(dateString) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(dateString).toLocaleDateString('pl-PL', options);
        },

        countDays(date1, date2) {
            // Parse the dates into JavaScript Date objects
            const start = new Date(date1);
            const end = new Date(date2);

            // Calculate the difference in milliseconds
            const differenceInMs = Math.abs(end - start);

            // Convert milliseconds to days (1 day = 24 * 60 * 60 * 1000 ms)
            const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
            return differenceInDays;
        }
    },
    components: {
        CalendarDaysIcon,
        UsersIcon,
        PuzzlePieceIcon,
        ShieldCheckIcon
    }
};
</script>
